import checkoutControlsHtml from './checkoutcontrols.component.html';
import './checkoutcontrols.component.scss';
import checkoutInvalidShippingAddressHtml from './checkoutinvalidshippingaddress.modal.html';
import checkoutInvoiceWarningHtml from './checkoutinvoicewarning.modal.html';
import checkoutMissingTaxNumberHtml from './checkoutmissingtaxnumber.modal.html';

class CheckoutControlsController {
    constructor($scope, $rootScope, $location, $window, $sce, CheckoutService, SnackbarService, ModalService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$window = $window;
        this.$sce = $sce;
        this.service = CheckoutService;
        this.SnackbarService = SnackbarService;
        this.ModalService = ModalService;
        this.translate = translateService;
        this.invoiceNotNeeded = false;

        this.stepTwoSubmitted = false;
    }

    $onInit() {
        this.service.step = parseInt(this.step);
        if (!this.service.loaded && !this.service.loadingCartItems) {
            this.service.load();
        }
    }

    downloadOffer() {
        if (!this.service.downloadOffer()) {
            this.scrollToShippingComponent();
        }
    }

    scrollToShippingComponent() {
        const shippingComponentBoundingRect = document.getElementById('checkout-shipment-component').getBoundingClientRect();
        this.$window.scrollTo({top: shippingComponentBoundingRect.top + window.scrollY - 82, left: 0, behavior: 'smooth'});
        this.SnackbarService.add(this.translate.t('checkout.selectShipmentMethod'), 'error', true, 5000);
    }

    setAddressesAndPayment() {
        if (this.service.userLogged) {
            const shipmentAddressId = this.service.addresses.shipment.length === 0 || !this.service.data.shipmentAddressId ? this.service.data.invoiceAddressId : this.service.data.shipmentAddressId;

            let address = this.service.getAddressById(shipmentAddressId);

            if (Object.keys(this.service.shopShipmentCountries).length > 0 && address && !(address.country in this.service.shopShipmentCountries)) {
                this.displayShipmentCountryWarning();

                return false;
            }

            address = this.service.getAddressById(this.service.data.invoiceAddressId);

            if (this.service.shopId === 4 &&
                address && address.company && (!address.tax_id || address.tax_id === '') && address.country === 'CZ' &&
                (this.service.summary.gros_value_of_products_with_discount + this.service.summary.gros_value_of_shipment) >= 10000) {
                this.displayTaxNumberWarning(this.translate.t('checkout.taxNumberRequiredForOrdersOverPrice'));
                return false;
            }

            if (this.service.shopId === 4 &&
                address && address.company && (!address.tax_id || address.tax_id === '') && address.country !== 'CZ') {
                this.displayTaxNumberWarning(this.translate.t('checkout.dataErrorMessages.taxNumberIsRequired'));
                return false;
            }

            if (this.service.shopId === 5 && address && address.company && !address.tax_id && address.no_tax_id === 0 && address.country === 'AT') {
                this.displayTaxNumberWarning(this.translate.t('checkout.dataErrorMessages.taxNumberIsRequired'), () => {
                    this.$rootScope.$emit('editInvoiceAddress', {address: address});
                });
                return false;
            }
        } else {
            this.service.userDataForm.$$setSubmitted();

            if (Object.keys(this.service.shopShipmentCountries).length > 0 && !(this.service.data.shipmentAddress.country in this.service.shopShipmentCountries)) {
                this.displayShipmentCountryWarning();

                return false;
            }
        }

        if (!this.service.stepTwoComplete) {
            let targetElementId = '';
            // Scroll to invalid section of the page
            if (!this.service.isUserDataFormValid) {
                targetElementId = 'tab-content-0';
            } else {
                targetElementId = 'checkout-payment-component';
                this.SnackbarService.add(this.translate.t('checkout.selectPaymentMethod'), 'error', true, 5000);
            }
            const targetElement = document.getElementById(targetElementId);
            const targetElementRect = targetElement.getBoundingClientRect();
            this.$window.scrollTo({top: targetElementRect.top + window.scrollY - 82, left: 0, behavior: 'smooth'});

            return false;
        }

        if (!this.service.userLogged &&
            this.service.shopId === 1 &&
            this.service.data.invoiceAddress.invoice === '0' &&
            this.service.data.shipmentAddress.companyName.length > 0 &&
            (!this.service.data.invoiceAddress.taxNumber ||
                this.service.data.invoiceAddress.taxNumber && this.service.data.invoiceAddress.taxNumber.length === 0
            ) &&
            !this.invoiceNotNeeded) {
            this.displayInvoiceWarning();

            return false;
        }

        if (this.service.userLogged && (!this.service.data.shipmentAddressId || this.service.addresses.shipment.length === 0)) {
            this.service.data.shipmentAddressId = this.service.data.invoiceAddressId;
        }

        this.stepTwoSubmitted = true;

        const selectedPayment = this.service.payments.find(payment => payment.id === this.service.summary.payment_id);

        if (this.service.data.invoiceAddress.invoice === '0') {
            this.service.data.invoiceAddress.companyName = '';
        }

        if (selectedPayment.module === 'billie' && !this.service.billieApproved) {
            this.service.payWithBillie().then(billieData => {
                // After a successful response set the invoice address from the returned Billie data object
                let billieAddress = this.service.normalizeBillieAddress(billieData);
                this.service.updateUserInvoiceAddress(billieAddress, () => {
                    this.setAddressesAndPaymentExecute();
                }).then(response => {}, reject => {
                    this.stepTwoSubmitted = false;
                });
            }, () => {
                this.stepTwoSubmitted = false;
            }).catch();
        } else {
            this.setAddressesAndPaymentExecute();
        }
    }

    setAddressesAndPaymentExecute() {
        this.service.setAddressesAndPayment().then(
            () => {
                this.$window.location.href = '/' + this.translate.t('checkout.routes.order', null) + '/' + this.translate.t('checkout.routes.summary', null);
            },
            () => {
                this.stepTwoSubmitted = false;
            }
        );
    }

    submit() {
        if (!this.service.data.terms) {
            this.SnackbarService.add(this.translate.t('checkout.termsAndPrivacyPolicyIsRequired'), 'error', true, 4000);
        } else {
            this.service.finalizeOrder().then(
                (data) => {
                    this.$window.location.href = data.url;
                },
                (data) => {
                    this.stepTwoSubmitted = false;

                    if (data.redirect) {
                        setTimeout(() => {
                            this.$window.location.href = data.redirect;
                        }, 1500);
                    }                    
                }
            );
        }
    }

    submitWithError() {
        if (this.service.userDataForm) {
            this.service.userDataForm.$$setSubmitted();
        }
        this.service.showAllErrors = true;
    }

    displayShipmentCountryWarning() {
        const shopShipmentCountries = this.service.shopShipmentCountries;

        this.ModalService.showModal({
            template: checkoutInvalidShippingAddressHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 0;
                    this.closeCallback = close;
                    this.shopShipmentCountries = shopShipmentCountries;
                    this.shopShipmentCountriesList = Object.keys(this.shopShipmentCountries).join(', ');
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                // Hide bootstrap modal
                modal.element.modal('hide');
            }
        }).then(modal => {
            // Show bootstrap modal
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            })
        });
    }

    displayInvoiceWarning() {
        this.ModalService.showModal({
            template: checkoutInvoiceWarningHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 0;
                    this.closeCallback = close;
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                // Hide bootstrap modal
                modal.element.modal('hide');
            }
        }).then(modal => {
            // Show bootstrap modal
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            })
            modal.close.then(result => {
                if (result === 'continue') {
                    this.invoiceNotNeeded = true;
                    this.setAddressesAndPayment();
                } else if (result === 'stop') {
                    this.service.data.invoiceAddress.invoice = '1';
                    if (!this.service.data.invoiceAddress.companyName) {
                        this.service.data.invoiceAddress.companyName = this.service.data.shipmentAddress.companyName;
                    }
                    this.service.tabSelected = 0;
                }
            });
        });
    }

    displayTaxNumberWarning(message, afterCloseCallback = null) {
        this.ModalService.showModal({
            template: checkoutMissingTaxNumberHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 0;
                    this.message = message;
                    this.closeCallback = close;
                    this.afterCloseCallback = afterCloseCallback;
                }

                close(data) {
                    this.closeCallback(data);
                    if (this.afterCloseCallback) {
                        this.afterCloseCallback();
                    }
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                // Hide bootstrap modal
                modal.element.modal('hide');
            }
        }).then(modal => {
            // Show bootstrap modal
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            })
        });
    }

    get lastItem() {
        if (!this.service.loaded || this.service.items.length === 0) {
            return {};
        }
        const lastItem = this.service.items[this.service.items.length - 1];
        this.$scope.lastItemSlug = this.$sce.trustAsHtml('/configurator/' + lastItem.slug);

        return lastItem;
    }
}

let checkoutControlsComponent = {
    bindings: {
        step: '<',
        form: '<',
        fixed: '<',
        action: '@'
    },
    template: checkoutControlsHtml,
    controller: CheckoutControlsController
}

export default checkoutControlsComponent;
